import { UserStatus } from "@generated/CurrentUser_Query.graphql";

export const selectNoAuthorizedMessageBasedOnGlobalUserStatus = (
	status: UserStatus | undefined,
) => {
	switch (status) {
		case "initialValidation":
			return "Ihr Konto wird derzeit geprüft. Dies kann bis zu 7 Tagen dauern. Währenddessen können Sie keine zertifizierten Fortbildungen durchführen. Nicht-zertifizierte Fortbildungen können Sie normal durchführen.";
		default:
			return "Dieser Service steht Ihnen nicht zur Verfügung.";
	}
};
